import React from 'react';
import { observer } from "mobx-react";
import { Button, Input, Space, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { config } from '../../../config';
import { fetchWithAuth } from '../../services/fetchWithAuth';
import { catalogImageUrl } from '../../images';
import './uploadImage.css';

const readAsDataUrl = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
});

/** Stores a catalog image through catalogue-service and returns its image id. */
export async function uploadCatalogImage(file) {
    const res = await fetchWithAuth(`${config().catalogueServiceBaseUrl}/images/catalog`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ data: await readAsDataUrl(file) }),
    });
    if (!res.ok) {
        throw new Error(`Image upload failed (${res.status})`);
    }
    const { imageId } = await res.json();
    return imageId;
}

@observer
export class UploadImage extends React.Component {
    fileInput = React.createRef();

    state = { uploading: false };

    onFileChosen = async ({ target }) => {
        const file = target.files && target.files[0];
        target.value = '';
        if (!file) return;
        this.setState({ uploading: true });
        try {
            this.props.onImageIdChange(await uploadCatalogImage(file));
        } catch (e) {
            message.error(e.message);
        } finally {
            this.setState({ uploading: false });
        }
    }

    onChange = ({ target }) => {
        const id = target.value;
        if (id.indexOf('http://') > -1 || id.indexOf("https://") > -1) {
            alert(`image id can't be a link`);
        }

        this.props.onImageIdChange(id);
    }

    render() {
        let { imageId, disabled } = this.props;
        if (typeof disabled === "undefined") {
            disabled = false;
        }

        return (
            <Space direction="vertical" size={6} style={{ width: '100%' }}>
                <Input
                    size="small"
                    value={imageId}
                    onChange={this.onChange}
                    placeholder="Image id"
                />

                <Space size={8} align="center">
                    {imageId && (
                        <img src={catalogImageUrl(imageId, 60)} alt="" height={60} />
                    )}
                    <input
                        ref={this.fileInput}
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={this.onFileChosen}
                    />
                    <Button
                        size="small"
                        icon={<UploadOutlined />}
                        onClick={() => this.fileInput.current.click()}
                        disabled={disabled}
                        loading={this.state.uploading}
                    >
                        Upload Image
                    </Button>
                </Space>
            </Space>
        );
    }
}
